import http from "./http-common";
import BannerModel from "../models/banner";

// Navbar APIs
// eslint-disable-next-line
export default new (class BannerService {
  // Get all members
  async getBanner(page) {
    return await http
      .get(`/banners?filters[id][$eq]=${page}&pLevel`)
      .then(async (response) => {
        if (response.data.data && response.data.data.length > 0) {
          const data = await BannerModel.get(response.data.data[0]);
          return data;
        }
        return null;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  /**
   * หาแบนเนอร์จาก caption (เช่น "infographic") ถ้าไม่มีใช้ของ id ที่ให้มาแทน
   * หน้าใหม่จะได้มีแบนเนอร์ของตัวเองโดยไม่ต้องรู้ id ในฐานข้อมูล
   */
  async getBannerByCaption(caption, fallbackId) {
    const found = await http
      .get(`/banners?filters[Banner][caption][$eqi]=${encodeURIComponent(caption)}&pLevel`)
      .then(async (response) =>
        response.data.data?.length > 0 ? BannerModel.get(response.data.data[0]) : null
      )
      .catch(() => null);
    return found || (fallbackId ? this.getBanner(fallbackId) : null);
  }
})();
